import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import MobileNavigation from './Navigation/MobileNavigation';
import MainNavigation from './Navigation/MainNavigation';

const Header: React.FC = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    // Заблокировать прокрутку при открытии меню
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isMenuOpen]);

    // Изменение цвета фона при скролле
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div
            className={` fixed w-full z-[100] lg:pl-[3%] lg:pr-[3%] px-4 lg:px-0 flex items-center justify-between transform transition-all duration-300 ${isScrolled ? 'bg-white text-[#273167] h-[50px] lg:h-[60px] 2xl:h-[70px] ' : 'bg-transparent text-white h-[55px] lg:h-[65px] 2xl:h-[75px]'}`}
        >
            <Link to="/">
                <img src={`${isScrolled ? '/logo.webp': isHomePage ? '/logo_white.webp' :'/logo.webp'}`} alt="" className="w-32 h-6 lg:w-52 lg:h-8 2xl:w-60 2xl:h-9" />
            </Link>
            <MobileNavigation isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} isScrolled={isScrolled} isHomePage={isHomePage} />
            <MainNavigation isScrolled={isScrolled} isHomePage={isHomePage} />
        </div>
    );
};

export default Header;